import { Component } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { PageError } from 'src/components/page-state';

// ----------------------------------------------------------------------

/**
 * Catches React render errors outside of the router error boundary (e.g. context providers).
 */
export class AppErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    const { error } = this.state;

    if (error) {
      return (
        <Box
          sx={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'background.default',
            py: 4,
            px: 2,
          }}
        >
          <Container maxWidth="sm">
            <PageError
              title="The application hit a problem"
              description="Please reload the page. If this keeps happening, contact support."
              error={
                import.meta.env.DEV
                  ? error instanceof Error
                    ? error
                    : new Error(String(error))
                  : undefined
              }
              onRetry={() => window.location.reload()}
              retryLabel="Reload"
            />
            <Button
              component={RouterLink}
              href={paths.root}
              variant="outlined"
              size="large"
              fullWidth
              sx={{ mt: 2 }}
            >
              Go to home
            </Button>
          </Container>
        </Box>
      );
    }

    return this.props.children;
  }
}
